export const getCameraPosition = function(){
  return {
    x: this.camera.position.x,
    y: this.camera.position.y,
    z: this.camera.position.z
  };
};
